import React, { useState } from 'react'
import CareersJobs from '../../../frontend/pages/careers/CareersJobs'

const ErbCareersJobs = () => {
  const [location, setLocation] = useState<string>('')
  return <CareersJobs location={location} setLocation={setLocation} />
}

export default ErbCareersJobs
